let capitalize = value=>{
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
}

// let ddMMyyyy = value=>{
//     let selectedDate = new Date(value);
//     let months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
//     let year = selectedDate.getFullYear();
//     let month = months[selectedDate.getMonth()];
//     let date = selectedDate.getDate();
//     let hour = selectedDate.getHours();
//     let min = selectedDate.getMinutes();
//     let sec = selectedDate.getSeconds();
//     let time = date + '/' + month + '/' + year ;
//     if(time == "1/01/1970" || time == "01/01/1970"){
//         return " - "
//     }
//     return time;
// }

let ddMMyyyy = value => {
    return moment(value).format('DD/MM/YYYY');
}

let ddMMyyyyHHmmSS = value => {
    return moment(value).format('DD/MM/YYYY HH:mm');
}

let dd_MM_yyyy = value=>{
    return moment.utc(value).format('DD.MM.YYYY');
}

let dd_MM_yyyy_tire = value=>{
    return moment.utc(value).format('DD-MM-YYYY');
}

let yyyy_MM_dd_tire = value=>{
    return moment.utc(value).format('YYYY-MM-DD');
}

let ddMMyyyyHHmm = value=>{
    return moment.utc(value).format('DD.MM.YYYY HH:mm');
}

let ddMMDDD = value=>{
    let selectedDate = new Date(value);
    let months = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
    let day = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
    let year = selectedDate.getFullYear();
    let month = months[selectedDate.getMonth()];
    let date = selectedDate.getDate();
    let hour = selectedDate.getHours();
    let min = selectedDate.getMinutes();
    let sec = selectedDate.getSeconds();
    let time = date + ' ' + month + ' ' + day[selectedDate.getDay()] ;
    if(time == "1/01/1970" || time == "01/01/1970"){
        return " - "
    }
    return time;
}

let MMddyyyy = value=>{
    let selectedDate = new Date(value);
    let months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
    let year = selectedDate.getFullYear();
    let month = months[selectedDate.getMonth()];
    let date = selectedDate.getDate();
    let hour = selectedDate.getHours();
    let min = selectedDate.getMinutes();
    let sec = selectedDate.getSeconds();
    let time = month + '/' + date + '/' + year ;
    if(time == "1/01/1970" || time == "01/01/1970"){
        return " - "
    }
    return time;
}

let timeStamp = value=>{
    let selectedDate = new Date(value);
    let months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
    let year = selectedDate.getFullYear();
    let month = months[selectedDate.getMonth()];
    let date = selectedDate.getDate();
    let hour = selectedDate.getHours();
    let min = selectedDate.getMinutes();
    let sec = selectedDate.getSeconds();
    let msec = selectedDate.getMilliseconds()
    let time = date + '/' + month + "/" + year + " " + hour + ":"+min+":"+sec + " " + msec;

    return time;
}

let getHour = value=>{
    return moment.utc(value).format('HH:mm')
}

let getDuration = value=>{
    let hour = 0;
    let min = 0;
    if(value> 60){
        hour = Math.floor(value/60);
    }
    min = value % 60;

    if(hour<10){
        hour = "0"+hour;
    }
    if(min<10){
        min = "0"+min;
    }
    return hour + ":"+min;
}

let toCurrency =  function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-TR', {
        style: 'currency',
        currency: 'EUR'
    });
    return formatter.format(value);
};

let toCurrencyTRY =  function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-TR', {
        style: 'currency',
        currency: 'TRY'
    });
    return formatter.format(value);
};

let getPax = value=>{
    let totalCount = 0
    for(let i=0;i<value.length;i++){
        totalCount += value[i].count;
    }
    return totalCount;
}

let numberWithPoint = value=>{
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export {capitalize, ddMMyyyy, dd_MM_yyyy, ddMMDDD, MMddyyyy, timeStamp, getHour, getDuration, getPax, numberWithPoint,
    ddMMyyyyHHmm, ddMMyyyyHHmmSS, toCurrency, dd_MM_yyyy_tire, yyyy_MM_dd_tire, toCurrencyTRY}